import { queryClient } from "../client-query";
import { globalStore } from "../eventstore/global-store";
import { ofType } from "../eventstore/of-type.operator";
import { successNotificationFromPromise } from "../notifications/utils";
import { ALL_MERCHANTS, ALL_SUBMERCHANTS } from "./resources";

export const merchantEffects = [
  globalStore
    .pipe(ofType("CREATE_MERCHANT_SUCCESS"))
    .subscribe(() =>
      queryClient.invalidateQueries([ALL_MERCHANTS, ALL_SUBMERCHANTS])
    ),

  globalStore
    .pipe(ofType("CREATE_MERCHANT_SUCCESS"))
    .subscribe(() => successNotificationFromPromise("added-merchant")),

  globalStore
    .pipe(ofType("AUTH_DONE"))
    .subscribe(() =>
      queryClient.invalidateQueries([ALL_MERCHANTS, ALL_SUBMERCHANTS])
    ),
];
